module.exports = __webpack_public_path__ + "static/media/birthday-gift.8b5c009a.svg";